import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1b6c200c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1b6c200c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c200c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6c200c')) {
      api.createRecord('1b6c200c', component.options)
    } else {
      api.reload('1b6c200c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1b6c200c&scoped=true&", function () {
      api.rerender('1b6c200c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24b1xc5kt91N2/JS/comp/GuestBox.vue"
export default component.exports